/** Valor padrão para input `datetime-local` (YYYY-MM-DDTHH:mm) no fuso do navegador/local. */
export function defaultDatetimeLocalValue(date: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/**
 * Converte `datetime-local` para string de relógio de Brasília sem Z
 * (backend grava Unspecified via DateTimeHelper).
 */
export function datetimeLocalToRecordedAtIso(value: string | null | undefined): string | undefined {
  const raw = String(value || '').trim();
  if (!raw) return undefined;
  // datetime-local já é parede local; não converter com toISOString() (vira UTC).
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(raw)) {
    const base = raw.length === 16 ? `${raw}:00` : raw;
    return base.replace(/Z$/i, '').replace(/[+-]\d{2}:\d{2}$/, '');
  }
  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return undefined;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}T${pad(parsed.getHours())}:${pad(parsed.getMinutes())}:${pad(parsed.getSeconds())}`;
}
